import {getToolMessage} from "./executedToolCallFormatters/toolMessageFormatter.ts";
import {addChild} from "../../../../../../messageObject/messageObjectUtils.ts";

export const addToolMessage = (finishedToolCall: any, results: any, llmRequestRefs: any, currentMessageRef: any, messagesSequenceRef: any, setMessages: any, messagesRef: any) => {
    const toolMessage = getToolMessage(finishedToolCall.id, finishedToolCall.name, results, llmRequestRefs);
    toolMessage.filePath = finishedToolCall.args?.filePath;
    addChild(toolMessage, currentMessageRef, messagesSequenceRef);

    llmRequestRefs.current.toolMessages.push(currentMessageRef.current);
    llmRequestRefs.current.messagesToWrite.push(currentMessageRef.current);
    setMessages(messagesRef.current.deepCopy());
};
